import { BookFormat } from "utils/server-constants/bookFormats";

/**
 * @param {Object} props
 * @param {string} props.format - The format of the book
 * @returns {React.ReactNode}
 */
const BookFormatLabel = ({ format }) => {
	const getFormatLabel = (format) => {
		const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "");

		if (!format) return [];
		if (format === BookFormat.Both) {
			return [BookFormat.Digital, BookFormat.Physical].map(capitalize);
		}
		return [capitalize(format)];
	};

	return (
		<div className="flex items-center gap-2 flex-wrap">
			{getFormatLabel(format).map((item) => (
				<span
					key={item}
					className="inline-flex items-center rounded-full border border-akgreener/20 bg-akgreener/10 px-3 py-1 text-xs font-semibold tracking-wide text-akgreenest"
				>
					{item}
				</span>
			))}
		</div>
	);
};

export default BookFormatLabel;
